export default {"src":"/_next/static/media/marketplace.e8c8bdca.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};